(() => {
  'use strict';

  const publishedPayloads = new WeakSet();
  const initializedForms = new WeakSet();
  const allowedKeys = new Set([
    'event',
    'form_name',
    'form_type',
    'page_path',
    'step',
    'step_name',
    'total_steps',
    'field_type',
    'field_group',
    'source'
  ]);

  const safeText = (value, maxLength = 120) => {
    if (typeof value !== 'string' && typeof value !== 'number') return undefined;
    return String(value).trim().slice(0, maxLength);
  };

  const sanitizePayload = (payload = {}) => {
    const clean = {};
    allowedKeys.forEach((key) => {
      if (!(key in payload)) return;
      if (key === 'step' || key === 'total_steps') {
        const numericValue = Number(payload[key]);
        if (Number.isFinite(numericValue)) clean[key] = numericValue;
        return;
      }
      const value = safeText(payload[key]);
      if (value) clean[key] = value;
    });
    return clean;
  };

  const publishPayload = (payload = {}) => {
    if (!payload || typeof payload !== 'object') return false;
    if (publishedPayloads.has(payload)) return false;
    publishedPayloads.add(payload);

    const clean = sanitizePayload(payload);
    const eventName = clean.event;
    if (!eventName || !eventName.startsWith('mujeron_form_')) return false;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(clean);

    try {
      const publishResult = window.Shopify?.analytics?.publish?.(eventName, clean);
      if (publishResult && typeof publishResult.catch === 'function') {
        publishResult.catch(() => {});
      }
    } catch (_error) {
      /* Customer Events puede tardar en estar disponible; dataLayer conserva el evento. */
    }

    document.documentElement.dataset.mjrLastFormEvent = eventName;
    document.dispatchEvent(new CustomEvent('mujeron:form-analytics', { detail: clean }));
    return true;
  };

  const emit = (action, detail = {}) => publishPayload({
    event: `mujeron_form_${action}`,
    page_path: window.location.pathname,
    ...detail
  });

  const initializeNewsletter = (form) => {
    if (!form || initializedForms.has(form)) return;
    initializedForms.add(form);

    const base = {
      form_name: 'Newsletter footer',
      form_type: 'newsletter',
      source: 'footer'
    };
    let started = false;

    emit('view', base);

    const start = () => {
      if (started) return;
      started = true;
      emit('start', base);
    };

    form.addEventListener('input', start, { passive: true });
    form.addEventListener('change', start, { passive: true });
    form.addEventListener('invalid', (event) => {
      emit('validation_error', {
        ...base,
        field_type: event.target?.type || event.target?.tagName?.toLowerCase() || 'campo'
      });
    }, true);
    form.addEventListener('submit', () => emit('submit_attempt', base));

    if (form.querySelector('[data-mjr-form-success], [data-mjr-form-error]')) {
      const hasErrors = Boolean(form.querySelector('[data-mjr-form-error]'));
      emit(hasErrors ? 'validation_error' : 'submit_success', base);
    }
  };

  const initialize = (root = document) => {
    root.querySelectorAll?.('.mjr-footer__form').forEach(initializeNewsletter);
  };

  window.MujeronFormAnalytics = Object.freeze({ emit, publishPayload });
  document.addEventListener('mujeron:form-event', (event) => publishPayload(event.detail));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
